import {clearAllCookies} from 'utils/functions/cookies';

export function resetSession() {
  clearAllCookies();
  localStorage.clear();
  sessionStorage.clear();
}
